import {
  FilterValue,
  GridConfig,
  SharedSelectTreeChangeEventOutput,
} from '@customer-portal/shared/models';

import { ActionFilterKey } from '../../constants';
import { ActionsModel } from '../../models';

export class RestoreActionFilters {
  static readonly type = '[Actions Details] Restore Filters';

  constructor(
    public companies?: number[],
    public services?: number[],
    public sites?: number[],
    public categories?: string[],
  ) {}
}

export class LoadInitialActionsAndFilters {
  static readonly type = '[Actions Details] Load Initial Actions And Filters';
}

export class LoadFilteredActions {
  static readonly type = '[Actions Details] Load Filtered Actions';
}

export class UpdateActionFilterCategories {
  static readonly type = '[Action Filter] Update Categories';

  constructor(public data: string[]) {}
}

export class UpdateActionFilterServices {
  static readonly type = '[Action Filter] Update Services';

  constructor(public data: number[]) {}
}

export class UpdateActionFilterCompanies {
  static readonly type = '[Action Filter] Update Companies';

  constructor(public data: number[]) {}
}

export class UpdateActionFilterSites {
  static readonly type = '[Action Filter] Update Sites';

  constructor(public data: SharedSelectTreeChangeEventOutput) {}
}
export class UpdateActionFilterByKey {
  static readonly type = '[Actions Details] Update Action Filter By Key';

  constructor(
    public data: unknown,
    public key: ActionFilterKey,
  ) {}
}

export class LoadHighPriorityAction {
  static readonly type = '[Action List] Load High Priority Actions';

  constructor(public isHighPriority: boolean) {}
}

export class LoadActionsListSuccess {
  static readonly type = '[Actions List] Load Actions List Items Success';

  constructor(public actions: ActionsModel[]) {}
}
export class LoadActionsListFail {
  static readonly type = '[Actions List] Load Actions List Fail';

  constructor(public error: string) {}
}

export class UpdateGridConfig {
  static readonly type = '[Actions List] Update Grid Config';

  constructor(public gridConfig: GridConfig) {}
}

export class NavigateFromAction {
  static readonly type = '[Actions] Navigate From Action';

  constructor(
    public id: string,
    public type: string,
  ) {}
}

export abstract class NavigateFromActionsListAction {
  constructor(public notificationsFilters: FilterValue[]) {}
}

export class NavigateFromActionsListToScheduleListView extends NavigateFromActionsListAction {
  static readonly type = '[Actions] Navigate From Action To Schedule List View';
}

export class ResetActionsFilters {
  static readonly type = '[Actions] Reset All Action Filters';
}

export class ResetActionsState {
  static readonly type = '[Actions] Reset Actions State';
}

export class MarkActionAsRead {
  static readonly type = '[Actions] Mark Action As Read';

  constructor(public id: number) {}
}
